import { Session } from 'next-auth'

import { BannersAudience,BannerTypes } from './api'

export const checkAuthBanner = (session: Session | null): string => {
    return session ? BannersAudience.authorized : BannersAudience.notAuthorized
  }

  export enum BannersPriority{
    'logged_in' = 1,
    'guests' = 2,
    'everyone' = 3
  }

export const filterAndSortBannersWithAuth = (banners: BannerTypes[], session: Session | null) => banners
  .filter(banner => {
    return (banner && 
    banner.webImage && 
    banner.mobileImage && 
    (banner.targetAudience === BannersAudience.everyone || 
     banner.targetAudience === checkAuthBanner(session)))
  })
  .sort((a, b) => BannersPriority[a.targetAudience] - BannersPriority[b.targetAudience])